import { FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const Footer = ({ color }) => {
  const year = new Date().getFullYear();
  const iconStyleString = `mx-2 text-2xl`
  return (
    <footer
      className={`fixed bottom-0 z-[999] flex w-full justify-between p-[2vw] text-white mix-blend-difference`}
    >
      <div className="flex justify-start">
        <p className="text-start ">© {year} Yung Men</p>
      </div>
      <div className="flex ">
        <FaInstagram
          className={iconStyleString}
          onClick={() => {
            window.open("https://www.instagram.com/yungmen4/", "_blank");
          }}
        />
        <FaXTwitter
          className={iconStyleString}
          onClick={() => {
            window.open("https://twitter.com/yungmen4", "_blank");
          }}
        />
        <FaTiktok
          className={iconStyleString}
          onClick={() => {
            window.open("https://www.tiktok.com/@yungmenz", "_blank");
          }}
        />
        <FaYoutube
          className={iconStyleString}
          onClick={() => {
            window.open("https://www.youtube.com/@yungmen4", "_blank");
          }}
        />
      </div>
    </footer>
  );
};

export default Footer;
